var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SplitViewTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"backButtonRoute":'/home',"dataModel":_vm.formModel,"formConfig":_vm.setFormConfig,"persistenceKey":'gl-account-list',"customMessages":_vm.customMessages}})}
var staticRenderFns = []

export { render, staticRenderFns }